import { render, staticRenderFns } from "./documentList.vue?vue&type=template&id=4381a8db&scoped=true&"
import script from "./documentList.vue?vue&type=script&lang=js&"
export * from "./documentList.vue?vue&type=script&lang=js&"
import style0 from "./documentList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./documentList.vue?vue&type=style&index=1&id=4381a8db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4381a8db",
  null
  
)

export default component.exports